import { useQuery } from '@tanstack/react-query';
import { fetchOsint, fetchDepositTrace, fetchCaseNetwork } from '../api/network';

export const useOsint = (caseNumber) =>
  useQuery({
    queryKey: ['osint', caseNumber],
    queryFn: () => fetchOsint(caseNumber),
    enabled: !!caseNumber,
    staleTime: 60_000,
  });

export const useDepositTrace = (caseNumber) =>
  useQuery({
    queryKey: ['deposit-trace', caseNumber],
    queryFn: () => fetchDepositTrace(caseNumber),
    enabled: !!caseNumber,
    staleTime: 60_000,
  });

export const useCaseNetwork = (caseNumber) =>
  useQuery({
    queryKey: ['case-network', caseNumber],
    queryFn: () => fetchCaseNetwork(caseNumber),
    enabled: !!caseNumber,
    retry: false,           // 404 just means no override
    staleTime: 60_000,
  });
